module.exports = __webpack_public_path__ + "static/media/urbangoo26.5a9cd8b5.webp";